import { render, staticRenderFns } from "./CatalogoCambioMolde.vue?vue&type=template&id=0f1d7988&"
import script from "./CatalogoCambioMolde.vue?vue&type=script&lang=js&"
export * from "./CatalogoCambioMolde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports